// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__kayT7","content":"styles_content__2g1MM","selectAll":"styles_selectAll__1gChh"};